import React, {
  Fragment,
  useRef,
  useState,
  useEffect,
  useCallback,
} from "react";
import { useEffectOnce } from "../../../hooks/useeffectonce";
import { useSelector, useDispatch } from "react-redux";
import {
  setProcessing,
  loadPage,
  pageLoaded,
  setPageValue,
  setPanes,
  deleteEntity,
  entityDeleted,
  setFavorite,
  disposePage,
} from "../../../redux/slices/reportinglocatorpageslice";
import { addNotification } from "../../../redux/slices/notificationsslice";
import {
  hideAppDialog,
  setAppDialog,
} from "../../../redux/slices/appdialogslice";
import { apiErrorsHandler, getErrorMessages } from "../../../api/httpclient";
import { useNavigate, useLocation, NavLink } from "react-router-dom";
import { Splitter } from "@progress/kendo-react-layout";
import { Page } from "../../page";
import { Loader } from "@progress/kendo-react-indicators";
import { Tooltip } from "@progress/kendo-react-tooltip";
import { Input } from "@progress/kendo-react-inputs";
import { Button } from "@progress/kendo-react-buttons";
import { List } from "../../../components/list";
import { ReportsViewer } from "../../../components/reportsviewer";
import {
  isNumeric,
  notificationDurationMiddle,
  beepFile,
} from "../../../lib/utils";
import { Checkbox } from "@progress/kendo-react-inputs";

import "./reportinglocatorpage.css";

import i18next from "i18next";
import { useTranslation } from "react-i18next";

const favItemRenderer = (currentTheme) => (props, item, index, t) => {
  return (
    <div key={item.Id} className={`list-item`}>
      <div className="list-item-title">{item.Title}</div>
      <div
        className="list-item-view-report"
        title={t("reporting.locator.view")}
        style={{ verticalAlign: "middle" }}
      >
        <NavLink to={`/reportingview/${item.ReferenceKey}`}>
          <div
            className="k-icon k-i-eye"
            style={{ verticalAlign: "middle" }}
          ></div>
        </NavLink>
      </div>
      <div
        className="list-item-edit-report"
        title={t("reporting.locator.edit")}
        style={{ verticalAlign: "middle" }}
      >
        <NavLink to={`/reportingdesign/${item.ReferenceKey}`}>
          <div className="k-icon k-i-edit"></div>
        </NavLink>
      </div>
      <div
        className="list-item-remove k-icon k-i-close"
        title={t("reporting.locator.remove")}
        onClick={(e) => props.onSetFavorite(item.Id)}
      ></div>
    </div>
  );
};
export const ReportingLocatorPage = (props) => {
  const dispatch = useDispatch();
  const currentUser = useSelector((state) => state.currentUser);
  const currentTheme = useSelector((state) => state.currentTheme);
  const appearance = useSelector((state) => state.appearance);
  const pageState = useSelector((state) => state.reportingLocatorPage);
  const filter = pageState.filter;
  const showSystemEntities = pageState.showSystemEntities;
  const items = pageState.items;
  const navigate = useNavigate();

  const { t } = useTranslation();

  //const [filter, setFilter] = useState("");
  const [handleAnimation, setHandleAnimation] = useState(false);

  useEffect(() => {
    setTimeout(() => {
      if (handleAnimation) setHandleAnimation(false);
    }, 1500);
  });

  /*initial page load*/
  useEffectOnce(() => {
    dispatch(loadPage(currentUser, t)).then(
      (response) => {},
      (err) => {
        //hide loader
        dispatch(setProcessing({ processing: false }));

        const handleResponseReceived = (state, dispatch, navigate, payload) => {
          let errorMessages = payload?.data?.ErrorMessages;

          //notify with error
          if (!errorMessages || errorMessages.length == 0)
            dispatch(
              addNotification({
                text: t("reporting.locator.loading_errormessage"),
                type: "error",
                closable: true,
                duration: notificationDurationMiddle,
                position: "topRight",
              }),
            );
          else {
            errorMessages = getErrorMessages(errorMessages, 1);
            dispatch(
              addNotification({
                text: errorMessages[0],
                type: "error",
                closable: true,
                duration: notificationDurationMiddle,
                position: "topRight",
              }),
            );
          }

          //go home
          navigate("/", { replace: true });
        };

        const handleUnhandled = (state, dispatch, navigate, payload) => {
          dispatch(
            addNotification({
              text: t("reporting.locator.unknown_error"),
              type: "error",
              closable: true,
              duration: notificationDurationMiddle,
              position: "topRight",
            }),
          );
          navigate("/", { replace: true });
        };

        apiErrorsHandler({}, dispatch, navigate, err, "/", {
          responseReceived: handleResponseReceived,
          unhandled: handleUnhandled,
        });
      },
    );

    return () => {
      dispatch(disposePage(true));
    };
  }, []);
  /*initial load*/

  /*splitter*/
  const handleOnSplitterChange = (e) => {
    dispatch(setPanes(e.newState));
  };
  /*splitter*/

  // const handleOnFilter = (keyword) => {
  //     //CONTAINS
  //     const resolvedFilter = (keyword === "" || keyword) ? keyword : filter;
  //     const _pageState = store.getState().reportingLocatorPage;

  //     if (!resolvedFilter || resolvedFilter.trim() == "")
  //         dispatch(setPageValue({id: "items", value: _pageState.items.map(e => ({...e, IsVisible: true}))}));
  //     else
  //     {
  //         const keyTerms = ["dashboard", "dashboards", "charts", "chart", "graph", "graphs", "table", "tables", "grid", "grids", "tabular"];
  //         const _filter = resolvedFilter.trim().toLowerCase();

  //         let predicate = null;

  //         if (keyTerms.indexOf(_filter) < 0)
  //             predicate = e => e.Title.toLowerCase().indexOf(_filter.toLowerCase()) >= 0 || e.Tags.toLowerCase().indexOf(_filter.toLowerCase()) >= 0;
  //         else if (_filter == "dashboard" || _filter == "dashboards")
  //             predicate = e => e.Title.toLowerCase().indexOf(_filter.toLowerCase()) >= 0 || e.Tags.toLowerCase().indexOf(_filter.toLowerCase()) >= 0 || e.IsDashboard == true;
  //         else if (_filter == "chart" || _filter == "charts")
  //             predicate = e => e.Title.toLowerCase().indexOf(_filter.toLowerCase()) >= 0 || e.Tags.toLowerCase().indexOf(_filter.toLowerCase()) >= 0 || e.IsChart == true;
  //         else if (_filter == "table" || _filter == "tables" || _filter == "grid" || _filter == "grids" || _filter == "tabular")
  //             predicate = e => e.Title.toLowerCase().indexOf(_filter.toLowerCase()) >= 0 || e.Tags.toLowerCase().indexOf(_filter.toLowerCase()) >= 0 || e.IsTable == true;

  //         dispatch(setPageValue({id: "items", value: _pageState.items.map(e => {
  //             if (predicate(e))//.Title.toLowerCase().indexOf(filter.toLowerCase()) >= 0 || e.Tags.toLowerCase().indexOf(filter.toLowerCase()) >= 0)
  //                 return {...e, IsVisible: true};
  //             else
  //                 return {...e, IsVisible: false};
  //         })}));
  //     }
  // };

  const handleOnDelete = (referenceKey) => {
    dispatch(
      setAppDialog({
        isVisible: true,
        className: "reportinglocator-page-are-you-sure",
        title: t("reporting.locator.warning"),
        content: t("reporting.locator.areyousure"),
        actions: {
          yesButton: {
            title: t("reporting.locator.yes"),
            handler: () => {
              dispatch(hideAppDialog());

              dispatch(deleteEntity(referenceKey, t)).then(
                (response) => {},
                (err) => {
                  dispatch(setProcessing({ processing: false }));

                  const handleResponseReceived = (
                    state,
                    dispatch,
                    navigate,
                    payload,
                  ) => {
                    let errorMessages = payload?.data?.ErrorMessages;

                    if (!errorMessages || errorMessages.length == 0)
                      errorMessages = [t("reporting.locator.unknown_error")];
                    else {
                      errorMessages = getErrorMessages(errorMessages, 1);

                      if (payload.data.ErrorCodes.EntityDoesNotExist)
                        dispatch(entityDeleted(referenceKey));
                    }

                    dispatch(
                      addNotification({
                        text: errorMessages[0],
                        type: "error",
                        closable: true,
                        duration: notificationDurationMiddle,
                        position: "topRight",
                      }),
                    );
                  };

                  const handleUnhandled = (
                    state,
                    dispatch,
                    navigate,
                    payload,
                  ) => {
                    let errorMessage = t("reporting.locator.unknown_error");
                    dispatch(
                      addNotification({
                        text: errorMessage,
                        type: "error",
                        closable: true,
                        duration: notificationDurationMiddle,
                        position: "topRight",
                      }),
                    );
                  };

                  apiErrorsHandler({}, dispatch, navigate, err, null, {
                    responseReceived: handleResponseReceived,
                    unhandled: handleUnhandled,
                  });
                },
              );
            },
          },
          noButton: { title: t("reporting.locator.no") },
        },
      }),
    );
  };

  const handleOnSetFavorite = (id) => {
    dispatch(setFavorite(id, t)).then(
      (response) => {},
      (err) => {
        //hide loader
        dispatch(setProcessing({ processing: false }));

        const handleResponseReceived = (state, dispatch, navigate, payload) => {
          let errorMessages = payload?.data?.ErrorMessages;

          if (!errorMessages || errorMessages.length == 0)
            errorMessages = [t("reporting.locator.unknown_error")];
          else errorMessages = getErrorMessages(errorMessages, 1);

          dispatch(
            addNotification({
              text: errorMessages[0],
              type: "error",
              closable: true,
              duration: 3,
              position: "topRight",
            }),
          );
        };

        const handleUnhandled = (state, dispatch, navigate, payload) => {
          let errorMessage = t("reporting.locator.unknown_error");
          dispatch(
            addNotification({
              text: errorMessage,
              type: "error",
              closable: true,
              duration: 3,
              position: "topRight",
            }),
          );
        };

        apiErrorsHandler({}, dispatch, navigate, err, null, {
          responseReceived: handleResponseReceived,
          unhandled: handleUnhandled,
        });
      },
    );
  };

  const favItems = pageState.items.filter((e) => e.IsFavorite == true);

  return (
    <Fragment>
      <Page
        id="reportingLocatorPage"
        className="reportinglocator-page"
        title={t("reporting.locator.reporting")}
        animation={props.animation}
      >
        <Fragment>
          {pageState.processing && (
            <div className="page-loader">
              <Loader
                size={"large"}
                type="infinite-spinner"
                themeColor={"primary"}
              />
              {pageState.processingText && (
                <div style={{ fontSize: 13, color: currentTheme.primary }}>
                  {pageState.processingText}
                </div>
              )}
            </div>
          )}
          {pageState.pageLoaded && (
            <Fragment>
              <div className="reportinglocator-desktop-view">
                <Splitter
                  style={{ border: "none" }}
                  panes={pageState.panes}
                  onChange={handleOnSplitterChange}
                >
                  <div className="reportinglocator-page-manager">
                    {pageState.canCreate && (
                      <div className="new-report">
                        <NavLink to="/reportingdesign/new">
                          <div className="new-container" style={{}}>
                            <div>
                              <div className="k-icon k-i-plus"></div>
                              <div>{t("reporting.locator.newreport")}</div>
                            </div>
                          </div>
                        </NavLink>
                      </div>
                    )}
                    <div className="filter-report">
                      <div
                        style={{
                          marginTop: 4,
                          display: "flex",
                          alignItems: "center",
                        }}
                      >
                        <Input
                          onChange={(e) => {
                            setHandleAnimation(true);
                            dispatch(
                              setPageValue({ id: "filter", value: e.value }),
                            );
                            // handleOnFilter(e.value);
                          }}
                          value={filter}
                          type="search"
                          autoFocus={true}
                          style={{
                            flex: 1,
                            padding: 8,
                          }}
                          placeholder={t("reporting.locator.search")}
                        />
                      </div>
                      <div
                        className={`checkbox-report ${
                          appearance.isRightToLeft ? "rtl" : "ltr"
                        }`}
                        style={{
                          marginTop: 10,
                          marginLeft: 0,
                        }}
                      >
                        <Checkbox
                          style={{
                            marginTop: -4,
                            marginRight: appearance.isRightToLeft ? "0" : "5px",
                            marginLeft: appearance.isRightToLeft ? "5px" : "0",
                          }}
                          value={showSystemEntities}
                          onChange={(e) => {
                            dispatch(
                              setPageValue({
                                id: "showSystemEntities",
                                value: e.value,
                              }),
                            );
                          }}
                          label={t("reporting.locator.show")}
                        />
                      </div>
                    </div>
                    {favItems?.length > 0 && (
                      <div className="fav-report">
                        <div className="title">
                          {t("reporting.locator.fav")}
                        </div>
                        <List
                          className="fav-reports"
                          items={favItems}
                          itemRenderer={favItemRenderer(currentTheme)}
                          onSetFavorite={handleOnSetFavorite}
                        />
                      </div>
                    )}
                  </div>
                  <div className={`right ${handleAnimation ? "fade" : null}`}>
                    <ReportsViewer
                      canCreate={pageState.canCreate}
                      canEdit={pageState.canEdit}
                      canDelete={pageState.canDelete}
                      onDelete={handleOnDelete}
                      onSetFavorite={handleOnSetFavorite}
                    />
                  </div>
                </Splitter>
              </div>
              <div className="reportinglocator-mobile-view">
                <div className="reportinglocator-mobile-heading">
                  <h1>{t("reporting.locator.reporting")}</h1>
                </div>
                <Input
                  onChange={(e) =>
                    dispatch(setPageValue({ id: "filter", value: e.value }))
                  }
                  value={filter}
                  type="search"
                  placeholder={t("reporting.locator.search")}
                  className="reportinglocator-mobile-search"
                />
                <div
                  className={`reportinglocator-mobile-system-filter checkbox-report ${
                    appearance.isRightToLeft ? "rtl" : "ltr"
                  }`}
                >
                  <Checkbox
                    value={showSystemEntities}
                    onChange={(e) =>
                      dispatch(
                        setPageValue({
                          id: "showSystemEntities",
                          value: e.value,
                        }),
                      )
                    }
                    label={t("reporting.locator.show")}
                  />
                </div>
                <div className="reportinglocator-mobile-list">
                  <ReportsViewer
                    canCreate={pageState.canCreate}
                    canEdit={pageState.canEdit}
                    canDelete={pageState.canDelete}
                    onDelete={handleOnDelete}
                    onSetFavorite={handleOnSetFavorite}
                  />
                </div>
              </div>
            </Fragment>
          )}
        </Fragment>
      </Page>
      <style>
        {`
                    /*page class*/
                    .reportinglocator-page
                    {
                        background-color: transparent;
                        padding: ${currentTheme.pagePadding};
                    }

                    .reportinglocator-page .k-splitter{
                        flex-direction: ${
                          appearance.isRightToLeft ? "row-reverse" : "row"
                        }
                    }

                      .reportinglocator-page .k-splitter .k-pane{
                      direction:${appearance.isRightToLeft ? "rtl" : "ltr"} 
                    }

                    .reportinglocator-desktop-view{
                    width:100%;
                    }
  
                      .reportinglocator-page .checkbox-report.rtl div[dir="ltr"] {
                        direction: rtl !important;
                      }

                      .reportinglocator-page .checkbox-report.ltr div[dir="rtl"] {
                        direction: ltr !important;
                      }

                    .reportinglocator-page .k-splitbar.k-splitbar-horizontal
                    {
                        background-color: ${currentTheme.paneSeparatorBg};
                    }

                    .reportinglocator-page .k-splitbar
                    {
                        width: ${currentTheme.paneSeparatorWidth};
                    }

                   
                    /*are you sure to delete*/
                    .reportinglocator-page-are-you-sure .k-widget
                    {
                      /*width of the dialog*/
                      width: 300px;
                    }    
                    
                    .reportinglocator-page-are-you-sure .k-widget .k-dialog-titlebar.k-header.k-header
                    {
                        /*bg color of the header*/
                        background-color: ${currentTheme.primary};
                    }


                    /*the manager*/
                    .reportinglocator-page > .content .reportinglocator-page-manager
                    {
                        display: flex;
                        flex-direction: column;
                        flex-wrap: nowrap;
                        height: 100%;
                        overflow: hidden;/* auto;*/
                        padding: 0 0 8px 0;
                        border: ${currentTheme.managerBorder};
                        border-radius: ${currentTheme.pageBorderRadius};
                        background-color: ${currentTheme.componentBgFaded};
                    }

                    .reportinglocator-page > .content .reportinglocator-page-manager .k-dropdownlist:focus,
                    .reportinglocator-page > .content .reportinglocator-page-manager .k-input:focus
                    {
                        box-shadow: none;
                    }

                    .reportinglocator-page > .content .reportinglocator-page-manager .k-dropdownlist,
                    .reportinglocator-page > .content .reportinglocator-page-manager .k-input
                    {
                        background-color: transparent;
                        color: ${currentTheme.componentText};
                    }


                    /*new report*/
                    .reportinglocator-page .new-report 
                    {
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        padding: 32px 16px;

                    }

                    .reportinglocator-page .new-report a
                    {
                        width: 80%;
                        display: inline-block;
                        color: ${currentTheme.componentText};
                        text-decoration: none;
                    }

                    .reportinglocator-page .new-report .new-container
                    {
                        padding: 16px 16px;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        border: 1px solid ${currentTheme.separatorColor};
                        border-radius: 8px;
                        color: ${currentTheme.componentText};   
                        opacity: 0.5;
                    }
                    
                    .reportinglocator-page .new-report .new-container:hover
                    {
                        cursor: pointer;
                        background-color: ${currentTheme.componentBgFaded};
                        border-color: ${currentTheme.separatorColor};
                        opacity: 1;
                        transition: opacity 1000ms;
                    }

                    .reportinglocator-page .new-report .new-container > div
                    {
                        display: flex;
                        justify-content: center;
                        align-items: center;
                    }                    

                    .reportinglocator-page .new-report .new-container .k-icon
                    {
                        color: ${currentTheme.componentText};   
                        font-size: 20px;
                        font-weight: 300;
                        margin-right: 4px;
                    }                                       

                    .reportinglocator-page .filter-report
                    {
                        display: flex;
                        flex-direction: column;
                        margin-top: 0px;
                        padding: 32px 16px;
                        border-top: 1px solid ${
                          currentTheme.componentBorderColor
                        };
                    }

                    .reportinglocator-page .filter-report .k-input::placeholder
                    {
                        color: ${currentTheme.componentText};
                        font-style: italic;
                    }

                    .reportinglocator-page .filter-report .k-button
                    {
                        background-color: transparent;
                        border-color: ${currentTheme.separatorColor};
                        border-radius: 50%;
                    }

                    .reportinglocator-page .filter-report .k-button .k-icon
                    {
                        color: ${currentTheme.componentText};
                    }

                    .reportinglocator-page .filter-report .k-button:hover
                    {
                        background-color: ${currentTheme.separatorColor};
                    }
 

                    .reportinglocator-page .fav-report
                    {
                        display: flex;
                        flex-direction: column;
                        padding: 32px 16px 16px 16px;
                        height: 100%;
                        overflow-y: hidden;
                        border-top: 1px solid ${
                          currentTheme.componentBorderColor
                        };
                    }

                    .reportinglocator-page .fav-report .title
                    {
                        color: ${currentTheme.componentText};
                        font-weight: 400;
                        font-size: 16px;
                        margin-bottom: 6px;
                        margin-top: 0px;
                        padding-bottom: 6px;
                        border-bottom: 1px solid ${
                          currentTheme.componentBorderColor
                        };
                    }

                    /*fav list*/
                    .reportinglocator-page .fav-report .list-container
                    {
                        /*border: 1px dashed ${currentTheme.separatorColor};*/
                        border-radius: 6px;
                        padding: 0;
                        overflow-y: auto;
                    }

                    .reportinglocator-page .fav-report .list-root
                    {
                        border-spacing: 0 6px;/*vertical space between 2 rows*/
                    }

                    .reportinglocator-page .fav-report .list-root .list-item
                    {
                    }

                    .reportinglocator-page .fav-report .fav-reports .list-item .list-item-img
                    {
                        
                    }
                    .reportinglocator-page .fav-report .fav-reports .list-item .list-item-img img
                    {
                        width: 40px;
                        height: auto;
                        aspect-ratio: 4 / 3;
                        border-radius: 6px;
                    }

                    .reportinglocator-page .fav-report .fav-reports .list-item .list-item-title
                    {
                        width: 100%;
                        vertical-align: middle;/*fine tuning*/
                    }
                    
                    .reportinglocator-page .fav-report .list-root .list-item-view-report a,
                    .reportinglocator-page .fav-report .list-root .list-item-edit-report a                    
                    {                
                        padding: 4px;
                        /*border: 1px solid ${
                          currentTheme.componentBorderColor
                        };
                        border-radius: 4px;*/
                        border: none;
                        display: flex;
                        align-items: center;
                        color: ${currentTheme.touchColor}!important;
                        text-decoration: none;
                    } 

                    .reportinglocator-page .fav-report .list-root .list-item-remove            
                    {                                       
                        color: ${currentTheme.error}!important;
                    } 

                    .reportinglocator-page .fav-report .fav-reports .list-item-remove:hover
                    {
                        color: ${currentTheme.touchColor};
                        cursor: pointer;
                    }

                    .reportinglocator-page .right                    
                    {
                        background-color: transparent;
                        height: 100%;
                        padding-left: 0px;
                        border: ${currentTheme.pageFormBorder};   
                        border-radius: ${currentTheme.pageBorderRadius};
                        display: flex;
                        flex-direction: column;
                    }                    

                    .reportinglocator-page .right.fade
                    {
                        animation-name: hide-report;
                        animation-duration: 2s;
                    }

                    @keyframes hide-report {
                        0%   {opacity:0};}
                    }

                    .reportinglocator-desktop-view {
                      flex: 0 0 100%;
                      width: 100%;
                      min-width: 0;
                      height: 100%;
                    }

                    .reportinglocator-desktop-view .k-splitter {
                      width: 100%;
                      height: 100%;
                    }

                    .reportinglocator-mobile-view {
                      display: none;
                    }

                    @media (max-width: 1024px) {
                      .reportinglocator-page > .content {
                        overflow-y: auto;
                      }

                      .reportinglocator-desktop-view {
                        display: none;
                      }

                      .reportinglocator-page .new-report {
                        display: none;
                      }

                      .reportinglocator-mobile-view {
                        display: flex;
                        flex-direction: column;
                        width: 100%;
                        min-height: 100%;
                        padding: 18px 16px calc(80px + env(safe-area-inset-bottom));
                        box-sizing: border-box;
                        background: ${currentTheme.componentBg};
                        color: ${currentTheme.componentText};
                        direction: ${appearance.isRightToLeft ? "rtl" : "ltr"};
                      }

                      .reportinglocator-mobile-heading h1 {
                        margin: 0 0 18px;
                        color: ${currentTheme.componentText};
                        font-size: 21px;
                        font-weight: 600;
                      }

                      .reportinglocator-page .reportinglocator-mobile-search {
                        margin-bottom: 12px;
                        background: transparent;
                      }

                      .reportinglocator-mobile-system-filter {
                        margin-bottom: 12px;
                      }

                      .reportinglocator-mobile-list {
                        width: 100%;
                        min-width: 0;
                      }
                    }

                 
                    `}
      </style>
    </Fragment>
  );
};

//export const ReportingLocatorPage = {Component: ReportingLocator};
